/** @format */
import isPropValid from '@emotion/is-prop-valid';
import { Heading } from '@mpb-com/feather/components/atoms/heading';
import { HeadingSize } from '@mpb-com/feather/components/atoms/heading/types';
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { styles } from './request-password-reset-confirmation.styles';

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Legacy code: do not use as an example.
export interface RequestPasswordResetConfirmationProps {
    /**
     * Selection ID for test purposes.
     */
    'data-testid'?: string;

    /**
     * Custom className
     */
    className?: string;
}

const StyledRequestPasswordResetConfirmation = styled('div').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

export const RequestPasswordResetConfirmation: FunctionComponent<
    RequestPasswordResetConfirmationProps
> = ({ ...otherProps }: RequestPasswordResetConfirmationProps) => {
    const { t } = useTranslation();

    return (
        <StyledRequestPasswordResetConfirmation {...otherProps}>
            <Heading size={HeadingSize.H2}>
                {t('Now, head to your emails.')}
            </Heading>
            <p>{t('Hit the link in your inbox to reset your password.')}</p>
        </StyledRequestPasswordResetConfirmation>
    );
};
